import { GetApiData } from "utils/http-client";

export const getAllClasses = async () => {
  return await GetApiData(`/class`, "GET", null, true);
};

export const getAllClassesById = async (id) => {
  return await GetApiData(`/class/teacher/${id}`, "GET", null, true);
};

export const getAllGroups = async () => {
  return await GetApiData(`/class/groups/me`, "GET", null, true);
};

export const CreateClass = async (data, type) => {
  return await GetApiData(`/class?type=${type}`, "POST", data, true);
};

export const AddStudentsToGroup = async (data) => {
  return await GetApiData(`/class/group/students`, "POST", data, true);
};

// Soft delete (archive) - for teachers and admins
export const deleteClass = async (id) => {
  return await GetApiData(`/class/${id}`, "DELETE", null, true);
};

// Restore archived class/group
export const restoreClass = async (id) => {
  return await GetApiData(`/class/${id}/restore`, "PUT", null, true);
};

// Get archived classes and groups
export const getArchivedClasses = async (page = 1) => {
  return await GetApiData(`/class/archived/list?page=${page}`, "GET", null, true);
};

// Permanent delete (hard delete) - admin only
export const permanentlyDeleteClass = async (id) => {
  return await GetApiData(`/class/${id}/permanent`, "DELETE", null, true);
};
